import { render } from "./PropertyThumbnail.vue?vue&type=template&id=c627b9c2"
import script from "./PropertyThumbnail.vue?vue&type=script&lang=js"
export * from "./PropertyThumbnail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__